module.exports = __webpack_public_path__ + "img/364.4f864505.jpg";